module.exports = __webpack_public_path__ + "img/uz.eb1e00b8.svg";